import { render, staticRenderFns } from "./ListingCandidates.vue?vue&type=template&id=3bd3852a&scoped=true"
import script from "./ListingCandidates.vue?vue&type=script&lang=ts"
export * from "./ListingCandidates.vue?vue&type=script&lang=ts"
import style0 from "./ListingCandidates.vue?vue&type=style&index=0&id=3bd3852a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd3852a",
  null
  
)

export default component.exports